import React from 'react';
import { useModal, DiscardCommentConfirmationModal, DiscardChangesConfirmationModal, } from '../components/modals';
export const useCancelFlow = ({ onCancel, id, isReply, }) => {
    const showModal = useModal();
    return () => {
        const result = onCancel();
        if (result.type === 'SILENT_CANCEL') {
            return result;
        }
        const ConfirmationModal = result.discard === 'COMMENT'
            ? DiscardCommentConfirmationModal
            : DiscardChangesConfirmationModal;
        return {
            type: 'PROMPT',
            onConfirm: result.onConfirm,
            highlightId: id,
            prompt: () => new Promise((resolve) => {
                showModal((toggle) => (React.createElement(ConfirmationModal, { toggle: toggle, isReply: isReply, onClose: (hasConfirmed) => {
                        if (hasConfirmed) {
                            resolve('CONFIRM_DISCARD');
                        }
                        else {
                            resolve('CANCEL_DISCARD');
                        }
                    } })));
            }),
        };
    };
};
export const useCancelFlowExecutor = (resolveCancelFlow) => {
    return () => {
        const result = resolveCancelFlow();
        if (result.type === 'SILENT_CANCEL') {
            result.cleanup();
            return;
        }
        else {
            const { prompt, onConfirm } = result;
            prompt().then((promptResult) => promptResult === 'CONFIRM_DISCARD' && onConfirm());
        }
    };
};
//# sourceMappingURL=use-cancel-flow.js.map